import { getUserData } from "../../../app/data/UserData";
import { timestamp } from "../../../app/data/validate";

function JobData({ db, currentUser }) {

    this.timesheet = ({ timesheetId }) => {
        return new Promise(async (resolve, reject) => {
            try {
                const digest = {};

                digest.timesheet = await db.get({ path: `intermediaries/${currentUser.uid}/timesheets/${timesheetId}`, context: 'JobData'  });
                digest.booking = await db.get({ path: digest.timesheet.bookingPath, context: 'JobData'  });
                digest.intermediary = await db.get({ path: `intermediaries/${currentUser.uid}`, context: 'JobData'  });
                digest.referral = digest.booking.referral;
                digest.courtCase = await db.get({ path: `organizations/${digest.booking.referral.organizationId}/cases/${digest.booking.referral.courtCaseId}`, context: 'JobData'  });
                digest.client = await db.get({ path: `organizations/${digest.booking.referral.organizationId}`, context: 'JobData'  });
                digest.organization = await db.get({ path: `organizations/${digest.booking.referral.organizationId}`, context: 'JobData' })
                digest.referrer = await db.get({  path: `users/${digest.booking.referral.uid}`, context: 'JobData'  });
                digest.member = await db.get({ path: `users/${currentUser.uid}`, context: 'JobData' });

                resolve(digest);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    this.getInvoice = ({ invoicePath }) => {
        return new Promise(async (resolve, reject) => {
            try {
                const invoice = await db.get({ path: invoicePath });

                resolve(invoice);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    this.saveInvoice = ({ invoice }) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { user, organization } = await getUserData({ db, currentUser });
                const path = `organizations/${organization.id}/${invoice.invoiceType}_invoices/${invoice.id}`;
                db.update({
                    path,
                    payload: {
                        ...invoice,
                        created: {
                            ts: timestamp(),
                            user,
                        }
                    }
                })
                    .then(() => resolve(path))
                    .catch(error => reject(error));
            }
            catch (error) {
                reject(error);
            }
        });
    }
}

export default JobData;